import { useQuery } from 'react-query'

import { LegalEntity } from '@webapp/platform/legal-entities/entities/LegalEntity'
import { legalEntityQueryConfig } from '@webapp/platform/legal-entities/query-configs/legalEntityQueryConfig'

interface UseQueryLegalEntitiesReturn {
  entities: LegalEntity[]
  isFetching: boolean
  isLoading: boolean
  isError: boolean
  refetch: () => void
}

/**
 * Fetches every LegalEntity in a single request.
 *
 * The list view splits active/inactive and paginates client-side off this
 * result, so there's no need to scope the query by tab. If server-side
 * filtering or paging is added later, broaden this hook's signature then.
 */
export const useQueryLegalEntities = (): UseQueryLegalEntitiesReturn => {
  const { data, isFetching, isLoading, isError, refetch } = useQuery(
    legalEntityQueryConfig.list()
  )

  const entities = (data ?? []).map((entity) => new LegalEntity(entity))

  return {
    entities,
    isFetching,
    isLoading,
    isError,
    refetch,
  }
}
